import React, { useContext } from 'react';
import { NewUserRequirementsViewContext } from '../contexts/NewUserRequirementsViewContext';
import { translations } from './constants';
import { FormattedText } from 'core/i18n';
import './RequirementsList.scss';
import { isCountrySpain } from 'utilities/multiLanguageHelper';

const RequirementsList = () => {
    const { handleToggleMoreDetailsModal } = useContext(NewUserRequirementsViewContext);
    const isSpain = isCountrySpain();

    return (
        <ul className="new-user-requirements__requirementList">
            <li className="requirement">
                <FormattedText value={translations.AGE} />
            </li>
            <li className="requirement">
                <FormattedText value={translations.RESIDENCE} />
            </li>
            <li className="requirement">
                <FormattedText value={translations.IDENTITY} />{' '}
                <button className="requirement-link" onClick={handleToggleMoreDetailsModal}>
                    <FormattedText value={translations.MORE_DETAILS} />
                </button>
            </li>
            <li className="requirement">
                <FormattedText value={translations.PHONE} />
            </li>
            <li className="requirement">
                <FormattedText value={translations.NOT_BE_CLIENT} />
            </li>
            {isSpain && (
                <li className="requirement requirement__requirement-jointholders">
                    <FormattedText value={translations.JOINT_HOLDERS} />
                </li>
            )}
        </ul>
    );
};

export default RequirementsList;
